import { useContext, useState } from 'react'
import { sessionStorage } from 'react-storage'
import { useUserActivity } from '@src/utils/useUserActivity'
import { useCurrentUser } from '@src/utils/useCurrentUser'
import {
  InviteCoWorkerWalkMeContext,
  InviteCoWorkerWalkMeConstants,
  getInviteCoWorkerStorageOverride,
} from '@src/routes/InviteCoWorker/InviteCoWorkerWalkMe'

export const useInviteCoWorkerWalkMe = () => {
  const { userIsLoggedIn } = useCurrentUser()
  const { state, setEnabled, dismissStep, startTour, advanceActiveStepNumber } =
    useContext(InviteCoWorkerWalkMeContext)
  const {
    userActivityData,
    trackingData,
    initialTrackingData,
    updateUserActivity,
  } = useUserActivity(
    InviteCoWorkerWalkMeConstants.TRACKING_DATA_KEY,
    getInviteCoWorkerStorageOverride(userIsLoggedIn)
  )

  const [dismissedAlert, setDismissedAlert] = useState(
    !!sessionStorage.getItem(InviteCoWorkerWalkMeConstants.DISMISSED_KEY)
  )
  const dismissedCount = trackingData?.numWalkMeDismissals || 0
  const shouldHideAlert =
    // adding this to disable for now since we added pay invoices walkme (TRCC-423)
    state.enabled ||
    dismissedAlert ||
    !userActivityData ||
    initialTrackingData?.hasCompletedWalkMe ||
    dismissedCount >= InviteCoWorkerWalkMeConstants.MAX_DISMISSALS

  const dismissAlert = (optOutOfWalkMe?: boolean) => {
    if (optOutOfWalkMe) setEnabled(false)
    sessionStorage.setItem(InviteCoWorkerWalkMeConstants.DISMISSED_KEY, true)
    setDismissedAlert(true)
    updateUserActivity({
      numWalkMeDismissals: (dismissedCount || 0) + 1,
      ...(optOutOfWalkMe != null && {
        hasOptedOutOfWalkMe: optOutOfWalkMe,
      }),
    })
  }

  return {
    state,
    setEnabled,
    dismissStep,
    startTour,
    dismissAlert,
    shouldHideAlert,
    advanceActiveStepNumber,
  }
}
